import { $Q, $Qll } from '../utils/query-selector';

let objectDataFaq = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": []
}

/**
 * Start the structured data FAQ
 */
const initStructuredData = () => {
  const lstAccordions = $Qll('.faq__accordions .accordion-item');
  if(lstAccordions.length == 0) return;

  lstAccordions.forEach(addInfoToObject);
  appendObjectToHead();
}

/**
 * This function fills the object with the data obtained by traversing the list of accordions
 * https://developers.google.com/search/docs/advanced/structured-data/faqpage
 * 
 * @param {Node} accordion Accordion List Node
 * @param {Index} i Cycle index
 */
const addInfoToObject = (accordion, i) => {
  const accordionTitle = $Q('.accordion-item__title', accordion);
  const accordionContent = $Q('.accordion-item__content p', accordion);
  
  objectDataFaq.mainEntity[i] = {
    "@type": "Question",
    "name": accordionTitle.innerText,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": accordionContent.innerText
    }
  }
}

/**
 * This function adds the object to the HTML head
 */
const appendObjectToHead = () => {
  const script = document.createElement('script');
  script.setAttribute('type', 'application/ld+json');
  script.textContent = JSON.stringify(objectDataFaq);
  document.head.appendChild(script);
}

initStructuredData();